/**
 * File: FlashController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class FlashController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, archiveService, TPWIZARDCONSTANT, CONSTANTS, Upload) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let resourceId = $state.params.resourceId;
        let plan = localStorageService.get("currentPlan")
        var save_url = TPWIZARDCONSTANT.API_SAVE_FLASH
        let isEdit = false;
        let isNewFileUploaded = false;
        $scope.file = {}
        let returnedJson = archiveService.getRedirectJson();
        archiveService.clearRedirectJson();
        if (returnedJson) {
            if (resourceId == returnedJson.resource) {
                if (returnedJson.returnData) {
                    $scope.isArchive = true;
                    $scope.archive = returnedJson.returnData;
                    $scope.isSaveDisable = false;
                    $scope.isSupportedFormat = true;
                }
            }
        }

        $scope.selectFromArchive = () => {
            let searchFilters = [];
            searchFilters.push({
                type: "tab",
                value: {
                    _id: "resources",
                    name: "Resources"
                },
                deletable: false,
                visible: true
            });
            searchFilters.push({
                type: "theme",
                value: {
                    _id: plan.theme_id,
                    name: plan.theme_title
                },
                deletable: true,
                visible: true
            });
            searchFilters.push({
                type: "resource_type",
                value: {
                    _id: "flash",
                    name: "Interactive Anime"
                },
                deletable: false,
                visible: true
            });
            let details = {
                searchFilters: searchFilters,
                previousState: {
                    state: $state.current.name,
                    params: $state.params
                },
                planId: planId,
                resource: resourceId,
                isMultiSelect: false,
                activeTab: "resources",
                resourceType: {
                    _id: "flash",
                    name: "Interactive Anime"
                }
            }
            archiveService.setRedirectJson(details)
            $state.go("archives");
        }

        $scope.openMenuAll = ($mdOpenMenu, ev) => {
            $mdOpenMenu(ev);
        }

        /*
         * Function to validate file
         * @file : Object - details of file which is uploaded
         * @return : null
         * @Developer: Arul Mozhi J
         */
        $scope.uploadFile = function(file) {
            isNewFileUploaded = true;
            let fileSize = ((file.size) / 1048576)
            if (file != undefined && file.name != undefined) {
                let extValue = file.name.split('.').pop();
                if (extValue === 'swf') {
                    $scope.isSupportedFormat = true
                    if (fileSize > 8.00) {
                        toastr.error("Please upload flash file size less than 15 mb")
                        return false
                    } else {
                        $scope.file = file
                    }
                } else {
                    $scope.isSupportedFormat = false
                    toastr.error("Please select supported .swf format")
                }
            }
        }

        /*
         * Function to upload a file
         * @file : Object - details of file which is uploaded
         * @return : null
         * @Developer: Arul Mozhi J
         */
        $scope.upload = (file) => {
            if ($scope.isArchive) {
                save($scope.archive.resource.url);
            } else {
                $scope.isSaveDisable = true;
                $scope.isLoading = true
                if (isEdit && !isNewFileUploaded) {
                    save($scope.url)
                    $scope.isLoading = false
                    $scope.isSaveDisable = false;
                }
                if (isNewFileUploaded) {
                    Upload.upload({
                        url: CONSTANTS.SERVER_UPLOAD,
                        data: {
                            file: file,
                            'userPath': userId + "/flash/"
                        }
                    }).then(function(resp) {
                        save(resp.data)
                    }, function(resp) {}, function(evt) {
                        $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        if ($scope.progressPercentage === 100) {
                            $scope.isLoading = false
                        }
                    });
                }
            }
        };

        /*
         * Function to save a file
         * @url : String of file to save
         * @return : null
         * @Developer: Arul Mozhi J
         */
        var save = (url) => {
            var params = {
                tp_id: planId,
                _id: resourceId,
                title: $scope.resource.title,
                url: url,
                status: $scope.resource.status,
                user_id: userId
            }
            authService.callAPI(save_url, "POST", params, function(resultObj) {
                let result = resultObj.result.data;
                if (result) {
                    localStorageService.set("currentPlan", result)
                    $scope.isSaveDisable = false;
                    toastr.success("Animation added successfully")
                    $rootScope.setStatus(resourceId, 'created')
                    _.defer(function() { $scope.$apply(); });
                } else {
                    toastr.error("Network Error")
                }
            })
        }

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })
                if ($scope.resource.url) {
                    $scope.file['name'] = $scope.resource.url.substring($scope.resource.url.lastIndexOf("/") + 1)
                    isEdit = true;
                    $scope.isSaveDisable = false;
                    $scope.isSupportedFormat = true;
                }
                _.defer(() => { $scope.$apply(); });
            }
        }

       /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "flash"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }

    };
}

export default FlashController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/flash.js